// src/pages/projects/components/UploadDocumentDialog.jsx
import React from 'react';
import {
  Box,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Typography
} from '@mui/material';
import { CloudUpload as UploadIcon } from '@mui/icons-material';

import { DOCUMENT_CATEGORIES } from '../../../constants/documentConstants';

const UploadDocumentDialog = ({ 
  open, 
  onClose, 
  uploadData, 
  setUploadData, 
  onFileSelect, 
  onUpload 
}) => {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Upload Document</DialogTitle>
      <DialogContent>
        <Box sx={{ pt: 1 }}>
          <Box sx={{ mb: 2, textAlign: 'center' }}>
            <Button
              variant="outlined"
              component="label"
              startIcon={<UploadIcon />}
              fullWidth
              sx={{ height: 100, borderStyle: 'dashed' }}
            >
              {uploadData.file ? uploadData.file.name : 'Select a file to upload'}
              <input
                type="file"
                hidden
                onChange={onFileSelect}
              />
            </Button>
          </Box>
          
          <TextField
            fullWidth
            label="Document Name"
            value={uploadData.name}
            onChange={(e) => setUploadData({ ...uploadData, name: e.target.value })}
            margin="normal"
          />
          
          <TextField
            fullWidth
            label="Description"
            value={uploadData.description}
            onChange={(e) => setUploadData({ ...uploadData, description: e.target.value })}
            margin="normal"
            multiline
            rows={3}
          />
          
          <FormControl fullWidth margin="normal">
            <InputLabel id="category-label">Category | Type</InputLabel>
            <Select
              labelId="category-label"
              id="type"
              value={uploadData.type}
              onChange={(e) => setUploadData({ ...uploadData, type: e.target.value })}
              label="Category"
            >
              {DOCUMENT_CATEGORIES.map(cat => (
                <MenuItem key={cat.value} value={cat.value}>
                  {cat.label}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          
          <Box sx={{ mt: 2 }}>
            <FormControl>
              <Typography component="label" variant="body2" htmlFor="client-visible-checkbox">
                <input
                  type="checkbox"
                  id="client-visible-checkbox"
                  checked={uploadData.isClientVisible}
                  onChange={(e) => setUploadData({ ...uploadData, isClientVisible: e.target.checked })}
                  style={{ marginRight: 8 }}
                />
                Make this document visible to clients
              </Typography>
            </FormControl>
          </Box>
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button 
          onClick={onUpload} 
          variant="contained" 
          disabled={!uploadData.file || !uploadData.name}
        >
          Upload
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default UploadDocumentDialog;